/**
 * WCC360 v2 — age bands.
 *
 * There is ONE component tree. A band changes which screens are served and
 * which wording each screen uses — both of those are data (`chaptersFor`,
 * `copy.ts`). If you find yourself forking a component on band, stop: the
 * fork belongs in the item set, not in React.
 */

export type Band = "18plus" | "15to18" | "12to14";

export const DEFAULT_BAND: Band = "18plus";

/** Accepts `?band=15-18`, `15to18`, `12-14`, `explorer`, `18+`, `18plus`. */
export function parseBand(raw: string | null | undefined): Band {
  const v = (raw ?? "").trim().toLowerCase();
  if (v === "15-18" || v === "15to18" || v === "15_18" || v === "teen") return "15to18";
  if (v === "12-14" || v === "12to14" || v === "12_14" || v === "explorer") return "12to14";
  return DEFAULT_BAND;
}

/** The canonical query-string value for a band. */
export function bandParam(b: Band): string {
  if (b === "15to18") return "15-18";
  if (b === "12to14") return "12-14";
  return "18+";
}

/** Storage is per-band so the flows never overwrite each other. */
export function storageKey(b: Band): string {
  if (b === "15to18") return "wcc360.v2.state.15to18";
  if (b === "12to14") return "wcc360.v2.state.12to14";
  return "wcc360.v2.state";
}

export const BAND_LABEL: Record<Band, string> = {
  "18plus": "18 and over",
  "15to18": "15 to 18",
  "12to14": "12 to 14",
};
